import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import theme from '@styles/theme';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill-new/dist/quill.snow.css';
// import 'react-image-crop/dist/ReactCrop.css';

export default createGlobalStyle`
  ${reset}

  @font-face {
    font-family: AppleSDGothicNeoBold;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-Bold.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: AppleSDGothicNeoSemiBold;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-SemiBold.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: AppleSDGothicNeoMedium;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-Medium.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: AppleSDGothicNeoRegular;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-Regular.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
  }


  @font-face {
    font-family: PretendardBold;
    src: url('/fonts/pretendard/Pretendard-Bold.woff') format('woff');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: PretendardSemiBold;
    src: url('/fonts/pretendard/Pretendard-SemiBold.woff') format('woff');
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: PretendardMedium;
    src: url('/fonts/pretendard/Pretendard-Medium.woff') format('woff');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: PretendardRegular;
    src: url('/fonts/pretendard/Pretendard-Regular.woff') format('woff');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: Tenda;
    src: url('/fonts/tenada/Tenada.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
  }

  * {
    box-sizing: border-box;
    -ms-overflow-style: auto; // 인터넷 익스플로러
    scrollbar-width: block; // 파이어폭스
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      display: block;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: ${({ theme }) => theme.colors.lightGrayFontColor} !important; // 스크롤바의 색상
    }
  }

  body {
    width: calc(100vw - 10px);
    font-size: 15px;
    font-family: PretendardRegular, AppleSDGothicNeoRegular, sans-serif;
    background-color: ${({ theme }) => theme.colors.whiteColor};
  }

  a {
    color: ${({ theme }) => theme.colors.blackColor};
    text-decoration: none;
  }

  textarea {
    resize: none;
  }

  input,
  textarea {
    font-size: 14px;
    font-family: PretendardRegular, sans-serif;
    border: none;
    outline: none;
    background-color: inherit;

    &::placeholder {
      font-size: 14px;
      font-family: PretendardRegular, sans-serif;
      color: ${({ theme }) => theme.colors.deepGrayFontColor};
    }

    &:disabled {
      color: ${({ theme }) => theme.colors.blackColor};
      background: inherit;
      background-color: ${({ theme }) => theme.colors.ultraLightGrayBorder};
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  button {
    font-size: 15px;
    font-family: PretendardRegular, sans-serif;
    padding: 0;
    outline: none;
    border: none;
    background-color: ${({ theme }) => theme.colors.whiteColor};
    cursor: pointer;
  }

  select {
    font-size: 14px;
    border: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;

    &:disabled {
      background-color: ${theme.colors.ultraLightGrayBorder};
    }
  }

  .Toastify__toast-container {
    width: 320px;
  }

  .Toastify__toast-body div {
    font-size: 15px;
    line-height: 1.2;
    white-space: pre-wrap;
    word-break: keep-all !important;
  }

  //h1 {
  //  font-size: 32px !important;
  //  font-weight: bold !important;
  //}
  //h2 {
  //  font-size: 24px !important;
  //  font-weight: bold !important;
  //}
  //h3 {
  //  font-size: 19px !important;
  //  font-weight: bold !important;
  //}
  //h4 {
  //  font-size: 16px !important;
  //  font-weight: bold !important;
  //}
  //h5 {
  //  font-size: 12px !important;
  //  font-weight: bold !important;
  //}
  //h6 {
  //  font-size: 10px !important;
  //  font-weight: bold !important;
  //}
  //
  //em {
  //  font-style: italic !important;
  //}
  //
  //b, strong {
  //  font-weight: bold !important;
  //}
  //
  //// React Quill Style
  //// font family
  //// AppleSDGothicNeo
  //.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='AppleSDGothicNeo']::before,
  //.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='AppleSDGothicNeo']::before {
  //  content: 'AppleSDGothicNeo';
  //  font-family: AppleSDGothicNeoMedium, sans-serif !important;;
  //}
  //
  //.ql-font-AppleSDGothicNeo {
  //  font-family: AppleSDGothicNeoMedium, sans-serif !important;;
  //}
  //
  //// Nanum Gothic
  //span.ql-font-NanumGothic,
  //.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='NanumGothic']::before,
  //.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='NanumGothic']::before {
  //  content: 'NanumGothic';
  //  font-family: 'Nanum Gothic', sans-serif !important;
  //}
  //
  //.ql-font-AppleSDGothicNeo {
  //  font-family: AppleSDGothicNeoMedium, sans-serif !important;;
  //}
  //
  //// pretendard
  //.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='pretendard']::before,
  //.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='pretendard']::before {
  //  content: 'pretendard';
  //  font-family: PretendardMedium, sans-serif !important;;
  //}
  //
  //.ql-font-pretendard {
  //  font-family: PretendardMedium, sans-serif !important;;
  //}
  //
  //// sans-serif
  //.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='sans-serif']::before,
  //.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='sans-serif']::before {
  //  content: 'sans-serif';
  //  font-family: sans-serif !important;;
  //}
  //
  //.ql-font-sans-serif {
  //  font-family: sans-serif !important;;
  //}
  //
  //// monospace
  //.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
  //.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  //  content: 'monospace';
  //  font-family: monospace !important;;
  //}
  //
  //.ql-font-monospace {
  //  font-family: monospace !important;;
  //}
  //
  //// font size
  //.ql-size-12px,
  //.ql-size span[data-value='12px']::before {
  //  font-size: 12px !important;
  //}
  //
  //.ql-size-14px,
  //.ql-size span[data-value='14px']::before {
  //  font-size: 14px !important;
  //}
  //
  //.ql-size-15px,
  //.ql-size span[data-value='15px']::before {
  //  font-size: 15px !important;
  //}
  //
  //.ql-size-16px,
  //.ql-size span[data-value='16px']::before {
  //  font-size: 16px !important;
  //}
  //
  //.ql-size-18px,
  //.ql-size span[data-value='18px']::before {
  //  font-size: 18px !important;
  //}
  //
  //.ql-size-20px,
  //.ql-size span[data-value='20px']::before {
  //  font-size: 20px !important;
  //}
  //
  //.ql-size-22px,
  //.ql-size span[data-value='22px']::before {
  //  font-size: 22px !important;
  //}
  //
  //.ql-size-24px,
  //.ql-size span[data-value='24px']::before {
  //  font-size: 24px !important;
  //}
  //
  //.ql-size-26px,
  //.ql-size span[data-value='26px']::before {
  //  font-size: 26px !important;
  //}
  //
  //.ql-size-28px,
  //.ql-size span[data-value='28px']::before {
  //  font-size: 28px !important;
  //}
  //
  //.ql-size-30px,
  //.ql-size span[data-value='30px']::before {
  //  font-size: 30px !important;
  //}
  //
  //.ql-size-32px,
  //.ql-size span[data-value='32px']::before {
  //  font-size: 32px !important;
  //}
  //
  //// Bold
  //.ql-editor strong {
  //  font-weight: bold !important;
  //}
  //
  //.ql-editor em {
  //  font-style: italic !important;
  //}
  //
  //.ql-align-right {
  //  text-align: right !important;
  //}
  //
  //.ql-align-center {
  //  text-align: center !important;
  //}
`;
